const TEXT1 = 'var(--ink)';
const TEXT2 = 'var(--slate)';

export default function BreakdownRow({ label, value, valueStyle }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '0.5px solid rgba(0,0,0,0.07)' }}>
      <span style={{ fontSize: 14, color: TEXT2 }}>{label}</span>
      <span style={{ fontSize: 14, color: TEXT1, fontWeight: 500, ...valueStyle }}>{value}</span>
    </div>
  );
}
